const getters = {
  device: state => state.app.device,

  avatar: state => state.user.avatar,
  deviceId: state => state.app.deviceId,
  nickname: state => state.user.userName,
  // 是否是超级管理员
  isSAdmin: state => {
    let isSAdmin = false
    if (state.user.roleList && state.user.roleList.length > 0) {
      state.user.roleList.map(role => {
        if (role.isAdmin) {
          isSAdmin = true
        }
      })
    }
    return isSAdmin
  },
}

export default getters
